import queuesStore from "@/app/queues/store/queues";
import queueStore from "@/app/queues/store/queue";

export default {
  modules: {
    queuesStore,
    queueStore,
  },
};
